/* Mon Beau Bon Bœuf — garde-fou livraison + reprise du paiement.
   Bloque le passage au paiement si aucun code postal desservi n'est confirmé,
   ouvre la fenêtre « On livre chez vous ? », puis — si le client saisit un code
   desservi — enchaîne automatiquement vers le paiement.
   Client-side (forfait non-Plus) : Shop Pay / paiement express contourne le panier. */
(function () {
  'use strict';
  var pendingUrl = null;

  function deliverable() {
    var r = window.mbbPostal && window.mbbPostal();
    return !!(r && r.deliverable);
  }
  function block(e, target) {
    e.preventDefault();
    e.stopImmediatePropagation();
    pendingUrl = target || '/checkout';
    if (window.mbbOpenPostal) window.mbbOpenPostal();
    if (window.mbbToast) window.mbbToast('Confirmez d’abord votre code postal de livraison.');
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('a[href*="/checkout"]');
    if (link) { if (!deliverable()) block(e, link.getAttribute('href')); return; }
    var btn = e.target.closest('button[name="checkout"]');
    if (btn) { if (!deliverable()) block(e, '/checkout'); return; }
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector) return;
    var isCheckout = e.submitter ? e.submitter.name === 'checkout' : !!f.querySelector('button[name="checkout"]');
    if (isCheckout && !deliverable()) block(e, '/checkout');
  }, true);

  // Reprise : après une vérification desservie, on file au paiement (petit délai
  // pour laisser voir le « On livre chez vous ! »).
  document.addEventListener('mbb:postal', function (e) {
    var d = e && e.detail;
    if (!d) return;
    if (d.deliverable && pendingUrl) {
      var url = pendingUrl;
      pendingUrl = null;
      setTimeout(function () {
        if (window.mbbClosePostal) window.mbbClosePostal();
        window.location.href = url;
      }, 700);
    } else if (!d.deliverable) {
      pendingUrl = null; // hors zone : on reste sur place
    }
  });
})();